import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import * as toastr from 'toastr';
import {DiscountService} from '../service-discount/discount.service';
import {LocalCustomerModel} from '../../../../models/LocalCustomerModel';
import {RegionModel} from '../../../../models/RegionModel';
import {LoaderService} from '../../../general-services/service-loader/loader.service';
import {DiscountModel} from '../../../../models/DiscountModel';
import {NumAnnoMeseService} from '../../../general-services/service-num-anno-mese/num-anno-mese.service';
import { MatDialog } from '@angular/material/dialog';
import {DialogSubmitDiscountComponent} from '../../../general-components/dialog-submit-discount/dialog-submit-discount.component';
import {ProviderModel} from '../../../../models/ProviderModel';
import {BaseGeneralComponent} from '../../../BaseGeneralComponent';

@Component({
  selector: 'app-new-discount-massive',
  templateUrl: './new-discount-massive.component.html',
  styleUrls: ['./new-discount-massive.component.scss']
})
export class NewDiscountMassiveComponent extends BaseGeneralComponent implements OnInit, OnDestroy {

  showActions: boolean;
  anagrafInSettings: boolean;

  discount: DiscountModel;
  localCustomerSelect: LocalCustomerModel;
  regionSelect: RegionModel;
  providerSelect: ProviderModel;
  saveDiscount: Subscription;
  numAnnoFrom: any;
  submitted = false;

  showLC: boolean;
  showRegion: boolean;
  showProvider: boolean;
  showDiscount: boolean;
  registerForm: FormGroup;

  allYear: any;
  getFirstYearSubscribe: Subscription;
  getPageSubscribe: Subscription;

  constructor(private route: ActivatedRoute, private router: Router,
              private discountService: DiscountService,
              private formBuilder: FormBuilder,
              private dialog: MatDialog,
              private loaderService: LoaderService,
              private annoMeseService: NumAnnoMeseService) {
    super();

    this.showActions = false;
    this.anagrafInSettings = true;
    this.showLC  = false;
    this.showRegion  = false;
    this.showProvider = false;
    this.showDiscount = false;
    this.discount = new DiscountModel();
    this.localCustomerSelect = new LocalCustomerModel();
    this.regionSelect = new RegionModel();

    this.providerSelect = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED));
    this.discount.provider = this.providerSelect;

    this.hideTables();
    this.getAllYear();
    this.getFirtsYear();

  }

  ngOnInit() {
    this.registerForm = this.formBuilder.group({
      annoFrom: [{value: '', disabled: false}, Validators.required],
      annoTo: [{value: '', disabled: false}, Validators.required],
      localCustomerCod: [{value: '', disabled: false}, Validators.required],
      region: [{value: '', disabled: false}, Validators.required],
      provider: [{value: this.providerSelect.cod, disabled: false}, Validators.required],
      discount: [{value: '', disabled: false}, Validators.required]
    });
  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.CONTRACTUAL_DATA], {queryParams: {selectedIndex: 1}});
  }

  save() {
    this.submitted = true;
    if (this.registerForm.valid) {
      this.discount.discount = this.registerForm.value.discount;
      this.discount.numAnno = null;
      this.discount.numAnnoFrom = this.registerForm.value.annoFrom;
      this.discount.numAnnoTo = this.registerForm.value.annoTo;
      event.preventDefault();
      this.loaderService.display(true);
      this.saveDiscount = this.discountService.saveMassive(this.discountService.baseUrl, this.discount)
        .subscribe(
          (result: any) => {
            if (result === -1) {
              toastr.options.timeout = 5000;
              toastr.warning('Duplicate item, cannot be created', 'Warning');
              this.loaderService.display(false);
            } else {
              this.loaderService.display(false);
              this.apriDialog(result);
              this.router.navigate([this.LINKS.CONTRACTUAL_DATA], {queryParams: {selectedIndex: 1}});
            }
          },
          error => {
            toastr.error('Discount was not created', 'Error');
          });
    }
  }

  getFirtsYear() {
    this.loaderService.display(true);
    this.getFirstYearSubscribe = this.annoMeseService.getFirtsYear()
      .subscribe(
        (result: any) => {
          this.numAnnoFrom = result;
          this.loaderService.display(false);
        });
  }

  ngOnDestroy(): void {
    if (this.saveDiscount) {
      this.saveDiscount.unsubscribe();
    }
  }

  getElementSelectedLC($event) {

    this.discount.localCustomer = $event.row;
    this.localCustomerSelect = $event.row;
    this.registerForm.patchValue({
      localCustomerCod: this.localCustomerSelect.cod
    });
  }

  getElementSelectedRegion($event) {
    this.discount.region = $event.row;
    this.regionSelect = $event.row;
    this.registerForm.patchValue({
      region: this.regionSelect.cod
    });


  }


  getElementSelectedProvider($event) {
    this.discount.provider = $event.row;
    this.providerSelect = $event.row;
    this.registerForm.patchValue({
      provider: this.providerSelect.cod
    });


  }

  toggleLC() {
    this.showLC = !this.showLC;
  }

  toggleRegion() {
    this.showRegion = !this.showRegion;
  }

  toggleProvider() {
    this.showProvider = !this.showProvider;
  }

  handleNumAnnoMeseFrom(value) {
    this.discount.numAnnoFrom = value;
    this.registerForm.patchValue({
      annoFrom: value
    });
  }
  handleNumAnnoMeseTo(value) {
    this.discount.numAnnoTo = value;
    this.registerForm.patchValue({
      annoTo: value
    });
  }

  // convenience getter for easy access to form fields
  get f() { return this.registerForm.controls; }

  getAllYear() {
    this.getPageSubscribe = this.annoMeseService.getAllYear()
      .subscribe(
        (result: any) => {
          this.allYear = result;
        });
  }

  resetAll() {
    this.resetLc();
    this.resetRegion();
    this.resetProvider();
    this.showLC = false;
    this.showRegion = false;
    this.showProvider = false;
  }

  resetLc() {
    this.registerForm.patchValue({
      localCustomerCod: ''
    });
    this.localCustomerSelect = new LocalCustomerModel();
  }

  resetRegion() {
    this.registerForm.patchValue({
      region: ''
    });
    this.regionSelect = new RegionModel();
  }

  resetProvider() {
    this.registerForm.patchValue({
      provider: ''
    });
    this.providerSelect = new ProviderModel();
  }

  hideTables() {
    this.showRegion = false;
    this.showLC = false;
    this.showProvider = false;

  }

  apriDialog(result: any) {
    const dialogRef = this.dialog.open(DialogSubmitDiscountComponent, {
      data: {result}
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });
  }
}
